// Product Added SuccessFull
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";

// Remove form cart
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
